import Hero from '../components/Hero/Hero';

const Loading = () => {
  return <Hero altTitle={"..."} />;
};

export default Loading;
